module.exports = __webpack_public_path__ + "img/jq1.e1f1cac2.jpg";